<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> EMPRESA </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="company.id"
          >{{ company.id }} - {{ company.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-tabs v-model="tab" background-color="grey lighten-2">
          <v-tab key="home">Empresa</v-tab>
          <v-tab
            key="frete"
            v-if="company.type === 'fra' || company.type === 'mul'"
            >Transportadoras</v-tab
          >
          <v-tab
            key="contatos"
            v-if="company.type === 'fra' || company.type === 'mul'"
            >Contatos</v-tab
          >
          <v-tab
            key="geral"
            v-if="company.type === 'fra' || company.type === 'mul'"
            >Informações Complementares</v-tab
          >
          <v-tab key="usuarios">Usuários</v-tab>
        </v-tabs>
        <v-container fluid>
          <v-tabs-items v-model="tab">
            <v-tab-item key="home" class="mt-4">
              <v-alert border="bottom" color="pink darken-1" dark v-if="error">
                <v-row align="center">
                  <v-col class="grow">
                    {{ error }}
                  </v-col>
                  <v-col class="shrink">
                    <v-btn text icon @click="error = ''">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
              <v-row>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-select
                    :items="typesCompany"
                    v-model="company.type"
                    label="Função"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    v-model="company.name"
                    class="text-field-uppercase"
                    label="Nome"
                    dense
                    outlined
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" xs="12" md="8"> </v-col> -->
                <!-- </v-row> -->
                <!-- <v-row> -->
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    v-model="company.description"
                    class="text-field-uppercase"
                    :label="labelName"
                    dense
                    outlined
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.code"
                    class="text-field-uppercase"
                    label="Código"
                    hint="Não preencher para que o código seja gerado automaticamente."
                    persistent-hint
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.document"
                    class="text-field-uppercase"
                    label="CNPJ"
                    v-mask="cnpjMask"
                    dense
                    outlined
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.state_registration"
                    class="text-field-uppercase"
                    label="Inscrição Estadual"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  md="2"
                  class="d-flex"
                  v-if="company.type === 'for'"
                >
                  <v-select
                    :items="providerTypes"
                    v-model="company.provider_type_id"
                    label="Tipo Fornecedor"
                    item-text="name"
                    item-value="id"
                    clearable
                    :required="company.type === 'for'"
                    :rules="[rules.required]"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  md="2"
                  class="d-flex"
                  v-if="company.type !== 'for'"
                >
                  <v-text-field
                    v-model="company.suframa"
                    class="text-field-uppercase"
                    label="SUFRAMA"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  md="2"
                  class="d-flex"
                  v-if="company.type !== 'for'"
                >
                  <v-text-field
                    v-model="company.royalties"
                    class="text-field-uppercase"
                    label="Royalties (%)"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  md="2"
                  class="d-flex"
                  v-if="company.type !== 'for'"
                >
                  <v-select
                    v-model="company.sample_products"
                    :items="optionsSampleProducts"
                    label="Pedido Produtos AM?"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="company.type !== 'for'">
                <!-- <v-col cols="12" xs="12" md="4" class="d-flex">
                  <v-select
                    :items="shippings"
                    v-model="company.favorite_carrier"
                    label="Transportadora Preferida"
                    item-text="name"
                    item-value="id"
                    clearable
                    dense
                    outlined
                  ></v-select>
                </v-col> -->
              </v-row>
              <v-row v-if="company.type === 'for'">
                <v-col cols="12" xs="12" md="2" class="pt-1">
                  <v-radio-group
                    v-model="company.type_minimum_order"
                    class="my-0 pt-0"
                    hide-details
                    dense
                    la
                  >
                    <v-radio
                      key="value"
                      :label="`Pedido Mínimo por Valor`"
                      value="value"
                    ></v-radio>
                    <v-radio
                      key="pair"
                      :label="`Pedido Mínimo por Quantidade`"
                      value="pair"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  md="2"
                  v-if="company.type_minimum_order == 'pair'"
                >
                  <v-text-field
                    outlined
                    dense
                    label="Pedido Mínimo"
                    v-model.number="company.minimum_order"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  md="2"
                  v-if="company.type_minimum_order != 'pair'"
                >
                  <v-text-field-money
                    v-model="company.minimum_order"
                    label="Pedido Mínimo"
                    v-bind:properties="{
                      prefix: 'R$',
                      readonly: false,
                      dense: true,
                      outlined: true,
                      clearable: false,
                      hideDetails: true,
                      placeholder: ' ',
                    }"
                    v-bind:options="{
                      locale: 'pt-BR',
                      length: 11,
                      precision: 2,
                      empty: null,
                    }"
                  />
                </v-col>
                <!-- <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.cash_discount"
                    class="text-field-lowercase text-end"
                    label="Desconto a Vista"
                    suffix="%"
                    reverse
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.days_for_discount"
                    class="text-field-lowercase text-end"
                    label="Dias para compra a vista"
                    reverse
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.material_discount"
                    class="text-field-lowercase text-end"
                    label="Desconto/Material"
                    suffix="%"
                    reverse
                    dense
                    outlined
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12" xs="12" md="2">
                  <v-switch
                    v-model="company.immediate_delivery"
                    class="mt-1"
                    label="Pronta Entrega"
                    :false-value="0"
                    :true-value="1"
                  ></v-switch>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-select
                    :items="grid_types"
                    v-model="company.grid_type"
                    label="Tipo de Grade"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.phone_number"
                    class="text-field-uppercase"
                    label="Celular"
                    v-mask="phoneMask"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-switch
                    v-model="company.status"
                    :label="`Status: ${getLabelStatus(company.status)}`"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Contato para Pedido</label>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-text-field
                    v-model="company.contact_name"
                    class="text-field-uppercase"
                    label="Nome do Contato"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-text-field
                    v-model="company.email"
                    class="text-field-lowercase"
                    label="Email Pedido"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.phone_number"
                    class="text-field-uppercase"
                    label="Celular"
                    v-mask="phoneMask"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    v-model="company.billing_email1"
                    class="text-field-lowercase remove-field"
                    label="Email 1"
                    dense
                    outlined
                    error
                    error-messages="Esse campo será removido"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    v-model="company.billing_email2"
                    class="text-field-lowercase remove-field"
                    label="Email 2"
                    dense
                    outlined
                    error
                    error-messages="Esse campo será removido"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    v-model="company.billing_email3"
                    class="text-field-lowercase remove-field"
                    label="Email 3"
                    dense
                    outlined
                    error
                    error-messages="Esse campo será removido"
                    readonly
                  ></v-text-field>
                </v-col> -->
              </v-row>
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Endereço de Entrega</label>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.delivery_zip_code"
                    class="text-field-uppercase"
                    label="CEP"
                    v-mask="zipCodeMask"
                    dense
                    outlined
                    hide-details
                    @blur="handleDeliveryZipCode()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    v-model="company.delivery_address"
                    class="text-field-uppercase"
                    label="Logradouro"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="1">
                  <v-text-field
                    v-model="company.delivery_number"
                    class="text-field-uppercase"
                    label="Número"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.delivery_complement"
                    class="text-field-uppercase"
                    label="Complemento"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.delivery_neighborhood"
                    class="text-field-uppercase"
                    label="Bairro"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.delivery_city"
                    class="text-field-uppercase"
                    label="Cidade"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-select
                    :items="ufs"
                    v-model="company.delivery_state"
                    label="UF"
                    dense
                    clearable
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-text-field
                    v-model="company.delivery_contact_name"
                    class="text-field-uppercase"
                    label="Nome do Contato"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.delivery_phone_number"
                    class="text-field-uppercase"
                    label="Telefone"
                    v-mask="phoneFixMask"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.delivery_cell_number"
                    class="text-field-uppercase"
                    label="Celular"
                    v-mask="phoneMask"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Endereço de Cobrança</label>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    dark
                    small
                    class=""
                    @click="replicateAddressBilling"
                    color="blue darken-2"
                    >Replicar Endereço de Entrega</v-btn
                  >
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.billing_zip_code"
                    class="text-field-uppercase"
                    label="CEP"
                    v-mask="zipCodeMask"
                    dense
                    outlined
                    hide-details
                    @blur="handleBillingZipCode()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    v-model="company.billing_address"
                    class="text-field-uppercase"
                    label="Logradouro"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="1">
                  <v-text-field
                    v-model="company.billing_number"
                    class="text-field-uppercase"
                    label="Número"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.billing_complement"
                    class="text-field-uppercase"
                    label="Complemento"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.billing_neighborhood"
                    class="text-field-uppercase"
                    label="Bairro"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="company.billing_city"
                    class="text-field-uppercase"
                    label="Cidade"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-select
                    :items="ufs"
                    v-model="company.billing_state"
                    label="UF"
                    clearable
                    dense
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-text-field
                    v-model="company.billing_contact_name"
                    class="text-field-uppercase"
                    label="Nome do Contato"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.billing_phone_number"
                    class="text-field-uppercase"
                    label="Telefone"
                    v-mask="phoneFixMask"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.billing_cell_number"
                    class="text-field-uppercase"
                    label="Celular"
                    v-mask="phoneMask"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    color="blue darken-3"
                    dark
                    class="mt-2"
                    @click="validate"
                  >
                    <v-icon left>mdi-send</v-icon> Salvar
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item
              v-if="company.type === 'fra' || company.type === 'mul'"
              key="frete"
              class="mt-4"
            >
              <v-row>
                <v-col cols="12">
                  <label class="text-h6"
                    >Transportadoras que a Franquia/Multimarcas Trabalha</label
                  >
                  <v-divider></v-divider>
                  <alert
                    :type="typeAlertShipping"
                    :visible="showAlertShipping"
                    :message="messageAlertShipping"
                    :clickClose="() => (showAlertShipping = false)"
                  ></alert>
                  <!-- <v-alert type="success" v-if="successSaveTechnology">
                    <template v-slot:close>
                      <v-icon @click="() => (successSaveTechnology = false)">
                        mdi-close
                      </v-icon>
                    </template>
                    Tecnologia Vinculada com Sucesso
                  </v-alert> -->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :items="shippings"
                    item-text="name"
                    item-value="id"
                    label="Transportadoras"
                    placeholder="Selecione"
                    hide-details
                    v-model="shippingSelected"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col>
                  <v-btn
                    color="blue darken-3"
                    dark
                    class="mt-1"
                    @click="addCompanyShipping()"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Adicionar Transportadora
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table dense fixed-header height="380">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left fs-12 text-no-wrap" width="100">
                            Preferida
                          </th>
                          <th class="text-left fs-12 text-no-wrap">Nome</th>
                          <th class="text-left fs-12 text-no-wrap" width="100">
                            Remover
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="shipping in companyHasShippings"
                          :key="shipping.id"
                        >
                          <td>
                            <v-radio-group v-model="radioGroup">
                              <v-radio
                                :key="shipping.shipping_company_id"
                                :value="shipping.shipping_company_id"
                                @change="
                                  updateCompanyShipping(
                                    shipping.shipping_company_id
                                  )
                                "
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td>
                            {{ shipping.shipping.name }}
                          </td>
                          <td>
                            <v-tooltip top color="error">
                              <!-- eslint-disable-next-line -->
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="red darken-1"
                                  @click="
                                    deleteCompanyShipping(
                                      shipping.shipping_company_id
                                    )
                                  "
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Deletar</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item
              v-if="company.type === 'fra' || company.type === 'mul'"
              key="contatos"
              class="mt-4"
            >
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Contatos</label>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <alert
                    :type="typeAlertContact"
                    :visible="showAlertContact"
                    :message="messageAlertContact"
                    :clickClose="() => (showAlertContact = false)"
                  ></alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="2">
                  <v-select
                    :items="typesContacts"
                    item-text="name"
                    item-value="id"
                    label="Contato Por:"
                    hide-details
                    v-model="typeContact"
                    dense
                    outlined
                    @input="changeTypesContacts()"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-select
                    :items="getTypesConcat(typesContacts2)"
                    item-text="name"
                    item-value="id"
                    label="Tipo:"
                    hide-details
                    v-model="typeContact2"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="contact_name"
                    class="text-field-uppercase"
                    label="Nome do Contato"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" v-if="typeContactHasPhone()">
                  <v-text-field
                    v-model="contact_value"
                    :label="getLabelContact()"
                    v-mask="contactMaskDynamic"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" v-else>
                  <v-text-field
                    v-model="contact_value"
                    :label="getLabelContact()"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-btn
                    color="blue darken-3"
                    dark
                    class="mt-1"
                    @click="addContact()"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Adicionar Contato
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headers_contacts"
                    :items="contacts"
                    :items-per-page="10"
                    class="elevation-1"
                  >
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.type="{ item }">
                      {{ capitalizeFirstLetter(item.method) }}
                      {{ capitalizeFirstLetter(item.type) }}
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip top color="error">
                        <!-- eslint-disable-next-line -->
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="red darken-1"
                            @click="deleteContact(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Deletar</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item
              v-if="company.type === 'fra' || company.type === 'mul'"
              key="geral"
              class="mt-4"
            >
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Informações Complementares</label>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.shopping"
                    class="text-field-uppercase"
                    label="Shopping"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.instagram"
                    class="text-field-uppercase"
                    label="Instagram"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-select
                    :items="typesICMS"
                    v-model="company.icms"
                    label="ICMS"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.open_date"
                    v-mask="dateMask"
                    class=""
                    label="Data de Abertura Loja"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2" class="d-flex">
                  <v-text-field
                    v-model="company.close_date"
                    v-mask="dateMask"
                    class=""
                    label="Data de Fechamento Loja"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    color="blue darken-3"
                    dark
                    class="mt-2"
                    @click="validate"
                  >
                    <v-icon left>mdi-send</v-icon> Salvar
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="usuarios" ckass="mt-4">
              <v-row>
                <v-col>
                  <label class="text-h6">Usuários</label>
                </v-col>
                <v-col class="d-flex justify-end">
                  <v-btn
                    @click="handleClickLinkUser()"
                    color="green darken-1"
                    class="white--text"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Vincular Usuário
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headersUsers"
                    :items="companyUsers"
                    :items-per-page="10"
                    class="elevation-1"
                  >
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.type="{ item }">
                      <v-chip label :color="getColorType(item.type)" dark>
                        {{ getLabelType(item.type) }}
                      </v-chip>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip top color="error">
                        <!-- eslint-disable-next-line -->
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="red darken-1"
                            @click="deleteUser(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Desvincular</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:no-data>
                      <v-btn
                        color="primary"
                        @click="getUsersByCompany(company.id)"
                      >
                        Recarregar
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-form>
    </div>
    <v-dialog v-model="dialogDeleteContact" max-width="500px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja Deletar?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelDialogDeleteContact()"
            >Fechar</v-btn
          >
          <v-btn
            color="red darken-1"
            dark
            @click="confirmDialogDeleteContact()"
          >
            <v-icon dark>mdi-delete</v-icon>
            Deletar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteUser" max-width="500px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja Desvincular?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelDialogDeleteUser()"
            >Fechar</v-btn
          >
          <v-btn color="red darken-1" dark @click="confirmDialogDeleteUser()">
            <v-icon dark>mdi-delete</v-icon>
            Desvincular
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogUsers" max-width="540px">
      <v-card>
        <v-toolbar color="green lighten-1" dark class="text-h5"
          >Usuários</v-toolbar
        >
        <v-card-text>
          <v-row class="ma-10">
            <v-col>
              <v-select
                v-model="usersSelected"
                :items="filterUsers(users)"
                item-text="name"
                item-value="id"
                :menu-props="{ maxHeight: '400' }"
                label="Usuários"
                multiple
                hint="Selecione os Usuários dessa empresa"
                persistent-hint
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class=""
            color="blue darken-1"
            outlined
            small
            @click="clickNewUser()"
          >
            <v-icon>mdi-plus</v-icon>
            Novo Usuário
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelDialogUsers()"
            >Fechar</v-btn
          >
          <v-btn color="green darken-1" dark @click="confirmDialogUsers()">
            <v-icon dark>mdi-check</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewUser" persistent max-width="500px">
      <v-card>
        <v-toolbar color="green ligthen-1" dark class="text-h5">
          Novo Usuário
          <v-progress-linear
            :active="loadingNewUser"
            :indeterminate="loadingNewUser"
            absolute
            bottom
            color="blue darken-4"
          ></v-progress-linear>
        </v-toolbar>
        <v-card-text class="mt-6">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="newUser.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :disabled="loadingNewUser"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="newUser.email"
                class=""
                label="Email"
                dense
                outlined
                required
                :disabled="loadingNewUser"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="newUser.password"
                class="text-field-uppercase"
                label="Senha"
                dense
                outlined
                type="password"
                required
                :disabled="loadingNewUser"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                :items="typesUser"
                v-model="newUser.type"
                label="Tipo"
                dense
                outlined
                :disabled="loadingNewUser"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            :disabled="loadingNewUser"
            text
            @click="cancelDialogNewUser()"
            >Fechar</v-btn
          >
          <v-btn
            color="green darken-1"
            :disabled="loadingNewUser"
            class="white--text"
            @click="confirmDialogNewUser()"
          >
            <v-icon dark>mdi-check</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as API from "@/api/requests/CompanyRequest";
import * as ProviderTypeAPI from "@/api/requests/ProviderTypeRequest";
import * as ShippingCompanyAPI from "@/api/requests/ShippingCompanyRequest";
import * as CompanyContactAPI from "@/api/requests/CompanyContactRequest";
import * as UserAPI from "@/api/requests/UserRequest";

import { getByZipCode } from "@/api/requests/ZipCodeRequest";

import AwesomeMask from "awesome-mask";
import { UF_LIST, TYPES_COMPANY } from "@/api/constants";
import Alert from "@/components/Alert";
import { TYPES_USER, USER_TYPES_DESCRIPTION } from "@/api/constants";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    zipCodeMask: "99.999-999",
    phoneMask: "(99) 99999-9999",
    phoneFixMask: "(99) 9999-9999",
    cpfMask: "999.999.999-99",
    cnpjMask: "99.999.999/9999-99",
    loading: false,
    typesCompany: [],
    providerTypes: [],
    ufs: [],
    tab: null,
    grid_types: [
      { id: 0, name: "Não Utilizado" },
      { id: 1, name: "Grade Fechada" },
      { id: 2, name: "Grade Aberta" },
    ],
    company: {
      id: "",
      name: "",
      description: "",
      document: "",
      state_registration: "",
      contact_name: "",
      email: "",
      phone_number: "",
      shopping: "",
      instagram: "",
      icms: "",
      open_date: "",
      close_date: "",
      type: "",
      provider_type_id: "",
      favorite_carrier: "",
      code: "",
      status: 1,
      sample_products: 0,
      delivery_address: "",
      delivery_number: "",
      delivery_neighborhood: "",
      delivery_complement: "",
      delivery_city: "",
      delivery_state: "",
      delivery_zip_code: "",
      delivery_contact_name: "",
      delivery_phone_number: "",
      delivery_cell_number: "",
      billing_email1: "",
      billing_email2: "",
      billing_email3: "",
      billing_address: "",
      billing_number: "",
      billing_neighborhood: "",
      billing_complement: "",
      billing_city: "",
      billing_state: "",
      billing_zip_code: "",
      billing_contact_name: "",
      billing_phone_number: "",
      billing_cell_number: "",
      cash_discount: "0.00",
      days_for_discount: 0,
      material_discount: "0.00",
      immediate_delivery: 0,
      grid_type: 0,
      royalties: 0,
      minimum_order: "0.00",
      type_minimum_order: "value",
    },
    valid: true,
    lazy: false,
    shippings: [],
    shippingSelected: "",
    companyShippings: [],
    error: "",
    loadingShipping: false,
    showAlertShipping: false,
    typeAlertShipping: "error",
    messageAlertShipping: "",
    typeAlertContact: "error",
    showAlertContact: false,
    messageAlertContact: "",
    companyHasShippings: [],
    radioGroup: "",
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    typesICMS: [
      {
        value: "",
        text: "Selecione",
      },
      {
        value: "simples-nacional",
        text: "Simples Nacional",
      },
      {
        value: "lucro-presumido",
        text: "Lucro Presumido",
      },
      {
        value: "lucro-real",
        text: "Lucro Real",
      },
      {
        value: "contribuinte",
        text: "Contribuinte",
      },
    ],
    typesContacts: [
      {
        id: "email",
        name: "Email",
      },
      {
        id: "telefone",
        name: "Telefone",
      },
      {
        id: "celular",
        name: "Celular",
      },
      {
        id: "whatsapp",
        name: "Whatsapp",
      },
    ],
    typesContacts2: [
      {
        id: "loja",
        name: "Loja",
      },
      {
        id: "franqueado",
        name: "Franqueado",
      },
      {
        id: "gerente",
        name: "Gerente",
      },
      {
        id: "cobrança",
        name: "Cobrança",
      },
      {
        id: "nfe",
        name: "Recebimento NFE",
      },
    ],
    typeContact: "email",
    typeContact2: "",
    contact_name: "",
    contact_value: "",
    redirectToList: true,
    headers_contacts: [
      { text: "Tipo", value: "type" },
      { text: "Nome", value: "name" },
      { text: "Contato", value: "contact" },
      { text: "Ação", value: "actions", align: "right" },
    ],
    contacts: [],
    contactDelete: {},
    dialogDeleteContact: false,
    headersUsers: [
      { text: "Nome", value: "name", width: 200 },
      { text: "Email", value: "email", width: 200 },
      { text: "Tipo", value: "type", width: 100 },
      {
        text: "Ação",
        value: "actions",
        align: "right",
        sortable: false,
        width: 100,
      },
    ],
    usersSelected: [],
    users: [],
    dialogUsers: false,
    companyUsers: [],
    dialogDeleteUser: false,
    userEditedId: "",
    dialogNewUser: false,
    newUser: {
      id: "",
      name: "",
      email: "",
      password: "",
      type: "",
      status: 1,
    },
    typesUser: [],
    userTypes: [],
    loadingNewUser: false,
    optionsSampleProducts: [
      { value: 0, text: "Não" },
      { value: 1, text: "Sim" },
    ],
  }),
  watch: {
    "company.type_minimum_order": function (val) {
      if (val === "pair") {
        this.company.minimum_order = parseInt(this.company.minimum_order);
      }
    },
  },
  computed: {
    labelName: function () {
      if (this.company.type === "fra") {
        return "Cidade/Shopping ou Bairro";
      } else if (this.company.type === "for") {
        return "Nome/Antigo Nome";
      } else {
        return "Cidade/Nome Fantasia";
      }
    },
    contactMaskDynamic: function () {
      if (this.typeContact === "telefone") {
        return "(99) 9999-9999";
      } else if (
        this.typeContact === "celular" ||
        this.typeContact === "whatsapp"
      ) {
        return "(99) 99999-9999";
      }
      return "(99) 9999-9999";
    },
  },
  created() {
    this.typesUser = TYPES_USER;
    this.userTypes = USER_TYPES_DESCRIPTION;
    this.typesUser = this.typesUser.filter((item) => {
      if (typeof item.header !== "undefined") {
        return item.header !== "Outros";
      }
      if (typeof item.value !== "undefined") {
        return item.value !== "photo" && item.value !== "royalties";
      }
    });
    console.log(this.typesUser);
    this.error = "";
    this.initialize();
    this.ufs = UF_LIST;
    this.typesCompany = [...TYPES_COMPANY];
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getCompany(this.$route.params.id);
        this.getCompanyShippings(this.$route.params.id);
      }
      this.getProviderTypes();
      this.getShippingCompanies();
      this.getUsers();
    },
    async getCompany(id) {
      this.loading = true;
      try {
        let response = await API.getById(id);
        this.company = response;
        this.company.type_minimum_order =
          this.company.type_minimum_order !== null
            ? this.company.type_minimum_order.toLowerCase()
            : "value";
        if (this.company.type_minimum_order == "pair") {
          this.company.minimum_order = parseInt(this.company.minimum_order);
        }

        this.company.open_date = this.dateFormatBr(this.company.open_date);
        this.company.close_date = this.dateFormatBr(this.company.close_date);

        // Validar
        this.contacts = this.company.contacts;
        this.companyUsers = this.company.users;
        // this.getContacts(id);
      } catch (error) {
        this.company = {};
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    async getProviderTypes() {
      this.loading = true;
      this.providerTypes = [];
      try {
        let res = await ProviderTypeAPI.getAll();
        let data = res;
        this.providerTypes = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        console.log(error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    async getShippingCompanies() {
      this.loading = true;
      this.shippings = [];
      try {
        let data = await ShippingCompanyAPI.getAll();
        this.shippings = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "Company" });
    },
    async validate() {
      if (this.$refs.form.validate()) {
        let keys = Object.keys(this.company);
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          if (
            typeof this.company[key] == "string" &&
            key !== "type" &&
            key !== "email" &&
            key !== "billing_email1" &&
            key !== "billing_email2" &&
            key !== "billing_email3" &&
            key !== "icms"
          ) {
            this.company[key] = this.company[key].toUpperCase();
          }
        }

        if (this.company.type == "for") {
          this.company.billing_email1 = null;
          this.company.billing_email2 = null;
          this.company.billing_email3 = null;
        } else {
          this.provider_type_id = "";
        }

        this.company.status = this.company.status ? 1 : 0;
        this.company.type_minimum_order =
          this.company.type_minimum_order.toLowerCase();
        if (this.company.type_minimum_order == "value") {
          this.company.minimum_order = this.company.minimum_order.replace(
            /,/gi,
            "."
          );
        }

        let data = this.company;
        data.open_date = this.dateFormatEua(data.open_date);
        data.close_date = this.dateFormatEua(data.close_date);
        if (this.company.id === "") {
          await this.post(data);
        } else {
          await this.update(this.company.id, data);
        }
      } else {
        this.tab = 0;
        this.goToTop();
        this.error = "Preencha os campos obrigátorios";
      }
    },
    async post(data) {
      this.loading = true;
      try {
        let res = await API.post(data);
        if (this.redirectToList) {
          this.goToBackList();
        } else {
          this.company = res.company;
        }
      } catch (error) {
        this.goToTop();
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    replicateAddressBilling() {
      this.company.billing_address = this.company.delivery_address;
      this.company.billing_number = this.company.delivery_number;
      this.company.billing_neighborhood = this.company.delivery_neighborhood;
      this.company.billing_complement = this.company.delivery_complement;
      this.company.billing_city = this.company.delivery_city;
      this.company.billing_state = this.company.delivery_state;
      this.company.billing_zip_code = this.company.delivery_zip_code;
      this.company.billing_cell_number = this.company.delivery_cell_number;
      this.company.billing_contact_name = this.company.delivery_contact_name;
      this.company.billing_phone_number = this.company.delivery_phone_number;
    },
    goToTop() {
      this.$vuetify.goTo(0, {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      });
    },
    async addCompanyShipping() {
      if (this.company.id === "") {
        this.redirectToList = false;
        await this.validate();
        if (this.company.id !== "") {
          this.$router.push({
            name: "CompanyEdit",
            params: { id: this.company.id },
          });
          await this.saveCompanyShipping();
        }
      } else {
        this.saveCompanyShipping();
      }
    },
    async saveCompanyShipping() {
      this.loadingShipping = true;
      try {
        await API.postShipping(this.company.id, {
          shipping: this.shippingSelected,
          favorite: 0,
        });
        this.showAlertShipping = true;
        this.typeAlertShipping = "success";
        this.messageAlertShipping = "Transportadora salva com sucesso";
        this.getCompanyShippings(this.company.id);
      } catch (error) {
        console.log(error);
        this.showAlertShipping = true;
        this.typeAlertShipping = "error";
        this.messageAlertShipping =
          "Houve um problema ao salvar a transportadora, tente novamente mais tarde";
      } finally {
        this.loadingShipping = false;
      }
    },
    async deleteCompanyShipping(shipping) {
      this.loadingShipping = true;
      try {
        await API.destroyShipping(this.company.id, shipping);
        this.showAlertShipping = true;
        this.typeAlertShipping = "success";
        this.messageAlertShipping = "Transportadora deletada com sucesso";
        this.getCompanyShippings(this.company.id);
      } catch (error) {
        console.log(error);
        this.showAlertShipping = true;
        this.typeAlertShipping = "error";
        this.messageAlertShipping =
          "Houve um problema ao deletar a transportadora, tente novamente mais tarde";
      } finally {
        this.loadingShipping = false;
      }
    },
    async getCompanyShippings(id) {
      this.loadingShipping = true;
      this.radioGroup = "";
      this.companyHasShippings = [];
      try {
        this.companyHasShippings = await API.getAllShipping(id);
        let shippingFavorite = this.companyHasShippings.find(
          (item) => item.favorite == 1
        );
        if (shippingFavorite !== undefined) {
          this.radioGroup = shippingFavorite.shipping_company_id;
        }
      } catch (error) {
        console.log(error);
        this.showAlertShipping = true;
        this.typeAlertShipping = "error";
        this.messageAlertShipping =
          "Houve um problema ao carregar as transportadoras, tente novamente mais tarde";
      } finally {
        this.loadingShipping = false;
      }
    },
    async updateCompanyShipping(shipping) {
      this.loadingShipping = true;
      try {
        await API.updateShipping(this.company.id, shipping, {
          favorite: 1,
        });
      } catch (error) {
        console.log(error);
        this.showAlertShipping = true;
        this.typeAlertShipping = "error";
        this.messageAlertShipping =
          "Houve um problema ao atualizar a transportadora, tente novamente mais tarde";
      } finally {
        this.loadingShipping = false;
      }
    },
    getTypesConcat(types) {
      if (this.typeContact === "") {
        return types;
      } else {
        let typeSelected = this.typesContacts.find(
          (item) => item.id == this.typeContact
        );
        return types.map((item) => ({
          ...item,
          name: `${typeSelected.name} ${item.name}`,
        }));
      }
    },
    getLabelContact() {
      if (this.typeContact === "") {
        return "Email";
      } else {
        let typeSelected = this.typesContacts.find(
          (item) => item.id == this.typeContact
        );
        return typeSelected.name;
      }
    },
    async addContact() {
      let data = {
        company_id: this.company.id,
        method: this.typeContact.toLowerCase(),
        type: this.typeContact2.toLowerCase(),
        name: this.contact_name.toUpperCase(),
        contact: this.contact_value.toLowerCase(),
      };
      if (this.company.id === "") {
        this.redirectToList = false;
        await this.validate();
        if (this.company.id !== "") {
          data.company_id = this.company.id;
          this.$router.push({
            name: "CompanyEdit",
            params: { id: this.company.id },
          });
          await this.saveContact(data);
        }
      } else {
        this.saveContact(data);
      }
    },
    async saveContact(data) {
      try {
        await CompanyContactAPI.post(data);
        this.messageAlertContact = "Contato salvo com sucesso";
        this.typeAlertContact = "success";
        this.showAlertContact = true;
        this.typeContact = "email";
        this.typeContact2 = "";
        this.contact_name = "";
        this.contact_value = "";
        this.getContacts(this.company.id);
      } catch (error) {
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getContacts(id) {
      this.loading = true;
      this.contacts = [];
      try {
        this.contacts = await CompanyContactAPI.getAll(`?company=${id}`);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteContact(item) {
      this.contactDelete = Object.assign({}, item);
      this.dialogDeleteContact = true;
    },
    async confirmDialogDeleteContact() {
      this.loading = true;
      try {
        await CompanyContactAPI.destroy(this.contactDelete.id);
        this.loading = false;
        this.getContacts(this.company.id);
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
      this.cancelDialogDeleteContact();
    },
    async cancelDialogDeleteContact() {
      this.dialogDeleteContact = false;
      this.$nextTick(() => {
        this.contactDelete = Object.assign({});
      });
    },
    dateFormatEua(value) {
      if (!value) return "";
      return value.split("/").reverse().join("-");
    },
    dateFormatBr(value) {
      if (!value) return "";
      return value.split("-").reverse().join("/");
    },
    changeTypesContacts() {
      this.contact_value = "";
    },
    typeContactHasPhone() {
      return (
        this.typeContact === "telefone" ||
        this.typeContact === "celular" ||
        this.typeContact === "whatsapp"
      );
    },
    capitalizeFirstLetter(str) {
      if (str === "") return "";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    async handleDeliveryZipCode() {
      if (this.company.delivery_zip_code !== "") {
        const value = this.company.delivery_zip_code
          .replace(".", "")
          .replace("-", "");
        try {
          let res = await getByZipCode(value);
          this.company.delivery_address = res.logradouro;
          this.company.delivery_number = "";
          this.company.delivery_neighborhood = res.bairro;
          this.company.delivery_complement = "";
          this.company.delivery_city = res.localidade;
          this.company.delivery_state = res.uf;
        } catch (error) {
          this.company.delivery_address = "";
          this.company.delivery_number = "";
          this.company.delivery_neighborhood = "";
          this.company.delivery_complement = "";
          this.company.delivery_city = "";
          this.company.delivery_state = "";
          console.log(error);
        }
      }
    },
    async handleBillingZipCode() {
      if (this.company.billing_zip_code !== "") {
        const value = this.company.billing_zip_code
          .replace(".", "")
          .replace("-", "");
        try {
          let res = await getByZipCode(value);
          this.company.billing_address = res.logradouro;
          this.company.billing_number = "";
          this.company.billing_neighborhood = res.bairro;
          this.company.billing_complement = "";
          this.company.billing_city = res.localidade;
          this.company.billing_state = res.uf;
        } catch (error) {
          this.company.billing_address = "";
          this.company.billing_number = "";
          this.company.billing_neighborhood = "";
          this.company.billing_complement = "";
          this.company.billing_city = "";
          this.company.billing_state = "";
          console.log(error);
        }
      }
    },
    async getUsers() {
      try {
        let res = await UserAPI.getAll();
        this.users = res;
        this.users = this.users.filter(
          (item) => item.type !== "photo" && item.type !== "royalties"
        );
        this.users = this.users.sort((a, b) => a.name > b.name);
      } catch (error) {
        console.log(error);
      }
    },
    handleClickLinkUser() {
      this.dialogUsers = true;
      this.usersSelected = [];
    },
    getColorType(type) {
      let findType = this.userTypes.find((item) => item.value === type);
      if (findType !== undefined) {
        return findType.color;
      } else {
        return "gray";
      }
    },
    getLabelType(type) {
      let findType = this.userTypes.find((item) => item.value === type);
      if (findType !== undefined) {
        return findType.text;
      } else {
        return "Outros";
      }
    },
    deleteUser(item) {
      this.userEditedId = item.id;
      this.dialogDeleteUser = true;
    },
    filterUsers(users) {
      return users.filter(
        (user) =>
          this.companyUsers.find((item) => item.id === user.id) === undefined
      );
    },
    cancelDialogUsers() {
      this.dialogUsers = false;
    },
    async confirmDialogUsers() {
      this.dialogUsers = false;
      try {
        await API.postUsersBatch(this.company.id, {
          users: this.usersSelected,
        });
        this.getUsersByCompany(this.company.id);
      } catch (error) {
        console.log(error);
      }
    },
    async getUsersByCompany(id) {
      this.companyUsers = [];
      try {
        let res = await API.getAllUser(id);
        this.companyUsers = res;
      } catch (error) {
        console.log(error);
      }
    },
    cancelDialogDeleteUser() {
      this.userEditedId = "";
      this.dialogDeleteUser = false;
    },
    async confirmDialogDeleteUser() {
      this.dialogDeleteUser = false;
      try {
        await API.destroyUser(this.company.id, this.userEditedId);
        this.userEditedId = "";
        this.getUsersByCompany(this.company.id);
      } catch (error) {
        console.log(error);
      }
    },
    async clickNewUser() {
      this.dialogUsers = false;
      this.dialogNewUser = true;
    },
    async confirmDialogNewUser() {
      this.dialogUsers = false;
      this.dialogNewUser = false;
      this.newUser.name = this.newUser.name.toLocaleUpperCase();
      this.loadingNewUser = true;
      try {
        let res = await UserAPI.post(this.newUser);
        this.resetNewUser();

        await API.postUsersBatch(this.company.id, {
          users: [res.user.id],
        });

        await this.getUsers();

        this.getUsersByCompany(this.company.id);
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingNewUser = false;
      }
    },
    cancelDialogNewUser() {
      this.dialogNewUser = false;
      this.loadingNewUser = false;
      this.resetNewUser();
    },
    resetNewUser() {
      this.newUser = {
        id: "",
        name: "",
        email: "",
        password: "",
        type: "",
        status: 1,
      };
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}

.text-field-lowercase input {
  text-transform: lowercase;
}
</style>
